/* Top Interiors global behaviour: menu drawer, search, basket count, toast, quick add, collection controls. */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var TI = (window.TI = window.TI || {});

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function store(key, val) {
    try {
      if (val === undefined) return window.localStorage.getItem(key);
      window.localStorage.setItem(key, val);
    } catch (e) { return null; }
  }

  function openLayer(el) {
    if (!el) return;
    el.classList.add('is-open');
    el.removeAttribute('hidden');
    document.body.classList.add('ti-lock');
    var focusEl = qs('[data-ti-autofocus]', el) || qs('a, button, input', el);
    if (focusEl) setTimeout(function () { focusEl.focus(); }, 30);
  }
  function closeLayer(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('hidden', '');
    document.body.classList.remove('ti-lock');
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-ti-open]');
    if (t) {
      e.preventDefault();
      var layer = document.getElementById(t.getAttribute('data-ti-open'));
      openLayer(layer);
      t.setAttribute('aria-expanded', 'true');
      return;
    }
    var c = e.target.closest('[data-ti-close]');
    if (c) {
      e.preventDefault();
      closeLayer(c.closest('.ti-drawer, .ti-search'));
      qsa('[data-ti-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') qsa('.ti-drawer.is-open, .ti-search.is-open').forEach(closeLayer);
  });

  var toastTimer;
  TI.toast = function (title, opts) {
    opts = opts || {};
    var el = qs('#ti-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'ti-toast';
      el.className = 'ti ti-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.classList.toggle('ti-toast--error', !!opts.error);
    el.innerHTML = '';
    var icon = document.createElement('div');
    icon.className = 'ti-toast__icon';
    icon.innerHTML = '<span class="msi" aria-hidden="true">' + (opts.error ? 'error' : 'check') + '</span>';
    var body = document.createElement('div');
    var t = document.createElement('p');
    t.className = 'ti-toast__title';
    t.textContent = title;
    body.appendChild(t);
    if (!opts.error) {
      var a = document.createElement('a');
      a.className = 'ti-toast__link';
      a.href = root + 'cart';
      a.textContent = 'View basket to checkout';
      body.appendChild(a);
    } else if (opts.text) {
      var p = document.createElement('p');
      p.className = 'ti-toast__link';
      p.textContent = opts.text;
      body.appendChild(p);
    }
    el.appendChild(icon);
    el.appendChild(body);
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 4500);
  };

  TI.setCount = function (n) {
    qsa('[data-ti-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.setAttribute('data-count', n);
    });
  };
  TI.refreshCart = function () {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { TI.setCount(cart.item_count); return cart; });
  };

  TI.addItems = function (items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) {
          var err = new Error(data.description || data.message || 'Could not add to basket');
          throw err;
        }
        return data;
      });
    }).then(function (data) {
      TI.refreshCart();
      return data;
    });
  };

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ti-add]');
    if (!form) return;
    e.preventDefault();
    var btn = qs('button[type="submit"]', form);
    if (btn) btn.disabled = true;
    var id = Number(qs('input[name="id"]', form).value);
    var qtyEl = qs('input[name="quantity"]', form);
    var qty = Number(qtyEl ? qtyEl.value : 1) || 1;
    TI.addItems([{ id: id, quantity: qty }])
      .then(function () { TI.toast('Added to your basket'); })
      .catch(function (err) { TI.toast('Could not add to basket', { error: true, text: err.message }); })
      .then(function () { if (btn) btn.disabled = false; });
  });

  document.addEventListener('change', function (e) {
    var s = e.target.closest('[data-ti-sort]');
    if (!s) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', s.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ti-filter-toggle]');
    if (!b) return;
    var panel = document.getElementById(b.getAttribute('aria-controls'));
    if (!panel) return;
    var open = panel.classList.toggle('is-open');
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  });

  document.addEventListener('submit', function (e) {
    var f = e.target.closest('form[data-ti-filters]');
    if (!f) return;
    qsa('input', f).forEach(function (i) {
      if ((i.type === 'number' || i.type === 'text') && i.value === '') i.disabled = true;
    });
  });

  function setView(cols) {
    var grid = qs('[data-ti-grid]');
    if (!grid) return;
    grid.classList.toggle('is-3', cols === '3');
    qsa('[data-ti-view]').forEach(function (b) {
      var on = b.getAttribute('data-ti-view') === cols;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ti-view]');
    if (!b) return;
    var cols = b.getAttribute('data-ti-view');
    setView(cols);
    store('ti-grid-cols', cols);
  });
  if (qs('[data-ti-grid]')) setView(store('ti-grid-cols') === '3' ? '3' : '4');

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ti-load-more]');
    if (!b) return;
    e.preventDefault();
    var next = b.getAttribute('href') || b.getAttribute('data-next');
    if (!next) return;
    b.classList.add('is-disabled');
    b.setAttribute('aria-busy', 'true');
    fetch(next, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = qs('[data-ti-grid]');
        var incoming = qs('[data-ti-grid]', doc);
        if (grid && incoming) {
          qsa('[data-ti-item]', incoming).forEach(function (n) { grid.appendChild(document.importNode(n, true)); });
        }
        var more = qs('[data-ti-more]');
        var newMore = qs('[data-ti-more]', doc);
        if (more && newMore) more.replaceWith(document.importNode(newMore, true));
        else if (more) more.remove();
        var shown = qs('[data-ti-shown]');
        if (shown && grid) shown.textContent = qsa('[data-ti-item]', grid).length;
        if (window.history && window.history.replaceState) window.history.replaceState({}, '', next);
      })
      .catch(function () {
        b.classList.remove('is-disabled');
        b.removeAttribute('aria-busy');
        window.location.href = next;
      });
  });

  qsa('[data-ti-recs]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = qs('[data-ti-recs]', doc);
        if (fresh && qs('[data-ti-rec-item]', fresh)) el.innerHTML = fresh.innerHTML;
        else el.closest('[data-ti-recs-wrap]') && el.closest('[data-ti-recs-wrap]').setAttribute('hidden', '');
      })
      .catch(function () {});
  });
})();
